var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12H35V36H13V12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 43.2C34.604 43.2 43.2 34.604 43.2 24C43.2 13.396 34.604 4.8 24 4.8C13.396 4.8 4.8 13.396 4.8 24C4.8 34.604 13.396 43.2 24 43.2ZM19.213 31.973C18.782 31.788 18.566 31.455 18.566 30.977V17.371C18.566 16.906 18.792 16.584 19.243 16.404C19.695 16.225 20.127 16.268 20.538 16.534L31.714 23.128C32.126 23.38 32.335 23.736 32.342 24.194C32.349 24.652 32.139 25.007 31.714 25.26L20.538 31.834C20.087 32.113 19.645 32.159 19.213 31.974V31.973Z",
    fill: "#6173FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleIcon);
export default __webpack_public_path__ + "static/media/play-circle-icon.b52899b8.svg";
export { ForwardRef as ReactComponent };